import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(theme => ({
  successContainer: {
    alignItems: 'center',
    gap: spacing.l,
    paddingBottom: spacing.s,
  },
  successTexts: {
    gap: spacing.xs,
  },
  trackCard: {
    alignSelf: 'stretch',
  },
  artistInfo: {
    alignSelf: 'stretch',
    borderTopWidth: 1,
    borderColor: theme.colors.borderColor,
    borderStyle: 'dashed',
    marginTop: -spacing.s,
    marginHorizontal: -spacing.l,
    paddingHorizontal: spacing.l,
    paddingTop: spacing.l,
    alignItems: 'center',
    gap: spacing.l,
  },
  artistInfoTexts: {
    gap: spacing.xs,
  },
}));
